import './../scss/app.scss';
import 'ios-inner-height';
import 'slick-carousel/slick/slick';
import './profet';
import './_filter';
import './_email-signup';
import './_footer.js';
import './_email-signup-footer';
import './_navigation';
import './_cookie-bar';
import './_global-goals-icon';
import './_news-feed-sidebar';
import './_dino-takeover';
